<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {

  },
  mounted() {
    // 初始化时判断一次
    this.checkScreenSize();
    // 监听窗口 resize 事件
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除监听，避免内存泄漏
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      const width = window.innerWidth;
      this.$store.dispatch('app/setScreenSize', width);
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue